import styled from 'styled-components';

import { Gender } from '@dreryk/egabinet-patient-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

const StyledTextView = styled(TextView)`
   flex: 1;
`;

type GenderTextViewProps = {
   readonly gender: Gender | null;
};

const GenderTextView = (props: GenderTextViewProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledTextView label={'common:gender'} testId={'gender'}>
         {props.gender ? translate(`common:genderTypes.${props.gender.toLowerCase()}`) : '-'}
      </StyledTextView>
   );
};

export { GenderTextView };
